// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icons-container[data-v-79bf621a] {\n  margin: 10px 20px 0;\n  overflow: hidden;\n}\n.icons-container .icon-item[data-v-79bf621a] {\n  margin: 20px;\n  height: 85px;\n  text-align: center;\n  width: 100px;\n  float: left;\n  font-size: 30px;\n  color: #24292e;\n  cursor: pointer;\n}\n.icons-container span[data-v-79bf621a] {\n  display: block;\n  font-size: 16px;\n  margin-top: 10px;\n}\n.icons-container .disabled[data-v-79bf621a] {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
